(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buildnexa-recently-viewed"] && !Shopify.designMode) return;
  try {
    
class BnRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    if (this.loaded) return;
    this.loaded = true;
    const key = 'buildnexa-recent-products-v1';
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      const history = Array.isArray(stored) ? stored.filter(h => typeof h === 'string' && /^[a-z0-9-]{1,255}$/.test(h)) : [];
      const previous = [...new Set(history)].filter(h => h !== this.dataset.handle).slice(0, 6);
      localStorage.setItem(key, JSON.stringify([this.dataset.handle, ...previous].slice(0, 7)));
      if (!previous.length) return;
      const cards = await Promise.all(previous.map(async handle => {
        try {
          const response = await fetch(`${this.dataset.root}products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(this.dataset.sectionId)}`);
          if (!response.ok) return null;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          return doc.querySelector('template[data-current-card]')?.content.firstElementChild?.cloneNode(true);
        } catch { return null; }
      }));
      if (!this.isConnected) return;
      const grid = this.querySelector('[data-recent-grid]');
      cards.filter(Boolean).forEach(card => grid.append(card));
      this.querySelector('[data-recent-content]').hidden = !grid.children.length;
    } catch { /* Browsing history is optional when storage is unavailable. */ }
  }
}
if (!customElements.get('bn-recently-viewed')) customElements.define('bn-recently-viewed', BnRecentlyViewed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class B2BMegaMenu extends HTMLElement {
    connectedCallback() {
      this.detailsItems = Array.from(this.querySelectorAll('[data-discovery-menu]'));

      this.onDocumentClick = this.handleDocumentClick.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onToggle = this.handleToggle.bind(this);
      this.onPageScroll = () => {
        this.hoverSuppressed = true;
        this.closeAll();
      };

      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);
      // Page scrolling must dismiss menus even before the sticky header hides.
      // Do not capture scroll events from inside a long menu panel.
      window.addEventListener('scroll', this.onPageScroll, { passive: true });
      this.detailsItems.forEach((details) => details.addEventListener('toggle', this.onToggle));
      this.hoverController = new AbortController();
      document.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'mouse') this.pointerPosition = [event.clientX, event.clientY];
      }, { signal: this.hoverController.signal, passive: true });
      this.detailsItems.forEach((details) => {
        details.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches) return;
          clearTimeout(this.hoverTimer);
          if (this.hoverSuppressed) return;
          this.hoverTimer = setTimeout(() => { details.open = true; }, 150);
        }, { signal: this.hoverController.signal });
        details.querySelector('summary').addEventListener('pointermove', (event) => {
          // Safari can send pointerenter when scrolling moves the trigger under
          // a stationary cursor. Require actual movement before hovering again.
          const moved = this.pointerPosition &&
            (event.clientX !== this.pointerPosition[0] || event.clientY !== this.pointerPosition[1]);
          if (!this.hoverSuppressed || event.pointerType !== 'mouse' || !moved) return;
          this.hoverSuppressed = false;
          clearTimeout(this.hoverTimer);
          this.hoverTimer = setTimeout(() => { details.open = true; }, 150);
        }, { signal: this.hoverController.signal });
        details.querySelector('summary').addEventListener('click', (event) => {
          event.preventDefault();
          this.hoverSuppressed = true;
          clearTimeout(this.hoverTimer);
          details.open = !details.open;
        }, { signal: this.hoverController.signal });
        details.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(this.hoverTimer);
          this.hoverTimer = setTimeout(() => {
            const keyboardFocus = details.contains(document.activeElement) &&
              document.activeElement.matches(':focus-visible');
            if (!keyboardFocus) details.open = false;
          }, 200);
        }, { signal: this.hoverController.signal });
      });
    }

    disconnectedCallback() {
      clearTimeout(this.hoverTimer);
      this.hoverController?.abort();
      this.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('click', this.onDocumentClick);
      window.removeEventListener('scroll', this.onPageScroll);
      this.detailsItems.forEach((details) => details.removeEventListener('toggle', this.onToggle));
    }

    handleToggle(event) {
      event.currentTarget.querySelector('summary').setAttribute('aria-expanded', event.currentTarget.open);
      if (!event.currentTarget.open) return;
      this.detailsItems.forEach((details) => {
        if (details !== event.currentTarget) details.open = false;
      });
    }

    closeAll() {
      // Cancel delayed hover opens as well as closing the visible panel.
      clearTimeout(this.hoverTimer);
      this.detailsItems.forEach((details) => (details.open = false));
    }

    handleKeydown(event) {
      const openDetails = this.detailsItems.find((details) => details.open);

      if (event.key === 'Escape' && openDetails) {
        event.preventDefault();
        this.closeAll();
        openDetails.querySelector('summary')?.focus();
        return;
      }

      if (event.key === 'ArrowDown' && event.target.matches('summary')) {
        const details = event.target.closest('details');
        details.open = true;
        details.querySelector('.bn-mega-menu__panel a')?.focus();
        event.preventDefault();
      }
    }

    handleDocumentClick(event) {
      if (this.contains(event.target)) return;
      this.closeAll();
    }
  }

  if (!customElements.get('b2b-mega-menu')) {
    customElements.define('b2b-mega-menu', B2BMegaMenu);
  }

  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.observer = null;

      this.setHeaderHeight();
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      window.addEventListener('resize', this.onResizeHandler);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.observer?.disconnect();
      window.clearTimeout(this.isScrolling);
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    createObserver() {
      this.observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        this.observer.disconnect();
      });

      this.observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch?.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = window.setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearch();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.querySelectorAll('header-menu').forEach((disclosure) => disclosure.close());
      this.querySelectorAll('.bn-discovery-menu details[open]').forEach((details) => (details.open = false));
    }

    closeSearch() {
      this.predictiveSearch?.close(true);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class CollectionGridEnhancements extends HTMLElement {
    connectedCallback() {
      this.filterDisclosure = this.querySelector('.bn-collection__filter-disclosure');
      this.filterBreakpoint = window.matchMedia('(min-width: 990px)');
      this.syncFilterDisclosure = () => {
        if (this.filterDisclosure) this.filterDisclosure.open = this.filterBreakpoint.matches;
      };
      this.syncFilterDisclosure();
      this.filterBreakpoint.addEventListener('change', this.syncFilterDisclosure);
      this.params = new URLSearchParams(window.location.search);
      this.unspsc = (this.params.get('unspsc') || '').trim();
      this.syncManualInputs();
      this.enhanceViewLinks();
      this.renderUnspscFilter();

      this.querySelectorAll('[data-native-sort]').forEach((select) => {
        select.addEventListener('change', () => select.form.requestSubmit());
      });
    }

    disconnectedCallback() {
      this.filterBreakpoint?.removeEventListener('change', this.syncFilterDisclosure);
    }

    syncManualInputs() {
      this.querySelectorAll('[data-unspsc-input], [data-unspsc-mirror]').forEach((input) => {
        input.value = this.unspsc;
      });
    }

    enhanceViewLinks() {
      if (!this.unspsc) return;

      this.querySelectorAll('[data-view-link]').forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('unspsc', this.unspsc);
        link.href = `${url.pathname}${url.search}`;
      });
    }

    renderUnspscFilter() {
      if (!this.unspsc) return;

      const normalizedNeedle = this.unspsc.toLowerCase();
      const items = Array.from(this.querySelectorAll('[data-unspsc]'));
      let visibleCount = 0;

      items.forEach((item) => {
        const code = (item.dataset.unspsc || '').toLowerCase();
        const matches = code.includes(normalizedNeedle);
        item.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      const count = this.querySelector('[data-unspsc-count]');
      if (count) {
        count.hidden = false;
        count.textContent = `· ${visibleCount} on this page match UNSPSC ${this.unspsc}`;
      }

      const empty = this.querySelector('[data-unspsc-empty]');
      if (empty) empty.hidden = visibleCount !== 0;

      const activeHost = this.querySelector('[data-active-filters]');
      const tagHost = this.querySelector('[data-active-filter-tags]');
      if (!activeHost || !tagHost) return;

      const removeUrl = new URL(window.location.href);
      removeUrl.searchParams.delete('unspsc');

      const tag = document.createElement('a');
      tag.className = 'bn-collection__filter-tag focus-inset';
      tag.href = `${removeUrl.pathname}${removeUrl.search}`;
      tag.innerHTML = `<span>UNSPSC: ${this.escapeHtml(this.unspsc)}</span><span aria-hidden="true">×</span><span class="visually-hidden">Remove UNSPSC lookup</span>`;
      tagHost.append(tag);
      activeHost.hidden = false;
    }

    escapeHtml(value) {
      const span = document.createElement('span');
      span.textContent = value;
      return span.innerHTML;
    }
  }

  if (!customElements.get('collection-grid-enhancements')) {
    customElements.define('collection-grid-enhancements', CollectionGridEnhancements);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-technical-tabs"] && !Shopify.designMode) return;
  try {
    
  class TechnicalTabs extends HTMLElement {
    connectedCallback() {
      this.tabList = this.querySelector('[data-tab-list]');
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

      if (!this.tabList || this.tabs.length === 0 || this.panels.length === 0) return;

      this.classList.add('is-enhanced');
      this.tabList.setAttribute('role', 'tablist');
      this.tabList.setAttribute('aria-orientation', 'horizontal');

      this.tabs.forEach((tab, index) => {
        const panelId = this.panelIdFor(tab);
        const panel = this.panels.find((candidate) => candidate.id === panelId);
        const tabId = `TechnicalTab-${this.dataset.sectionId || 'product'}-${index}`;

        tab.id = tabId;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panelId);
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');

        if (panel) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabId);
          panel.setAttribute('tabindex', '0');
          panel.hidden = true;
        }

        tab.addEventListener('click', (event) => {
          event.preventDefault();
          this.activate(tab, true);
        });

        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      const hashTarget = window.location.hash ? document.getElementById(window.location.hash.slice(1)) : null;
      const initialPanel = hashTarget ? hashTarget.closest('[data-tab-panel]') : null;
      const initialTab =
        this.tabs.find((tab) => this.panelIdFor(tab) === initialPanel?.id) ||
        this.tabs.find((tab) => this.panelIdFor(tab) === window.location.hash.slice(1)) ||
        this.tabs[0];

      this.activate(initialTab, false);

      if (hashTarget && hashTarget !== initialPanel) {
        requestAnimationFrame(() => {
          hashTarget.scrollIntoView({ block: 'center' });
          if (typeof hashTarget.focus === 'function') hashTarget.focus({ preventScroll: true });
        });
      }

      window.addEventListener('hashchange', this.onHashChange);
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.onHashChange);
    }

    onHashChange = () => {
      const target = window.location.hash ? document.getElementById(window.location.hash.slice(1)) : null;
      const panel = target?.matches('[data-tab-panel]') ? target : target?.closest('[data-tab-panel]');
      const tab = this.tabs.find((candidate) => this.panelIdFor(candidate) === panel?.id);

      if (tab) {
        this.activate(tab, false);
        requestAnimationFrame(() => {
          panel.scrollIntoView({ block: 'start' });
          panel.focus({ preventScroll: true });
        });
      }
    };

    panelIdFor(tab) {
      return tab.getAttribute('href').split('#').pop();
    }

    activate(tab, updateUrl) {
      const activePanelId = this.panelIdFor(tab);

      this.tabs.forEach((candidate) => {
        const selected = candidate === tab;
        candidate.setAttribute('aria-selected', String(selected));
        candidate.setAttribute('tabindex', selected ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== activePanelId;
      });

      if (updateUrl) {
        window.history.replaceState(null, '', tab.href);
      }
    }

    onKeydown(event, currentIndex) {
      let nextIndex = null;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;

      if (nextIndex === null) return;

      event.preventDefault();
      const nextTab = this.tabs[nextIndex];
      nextTab.focus();
      this.activate(nextTab, true);
    }
  }

  if (!customElements.get('technical-tabs')) {
    customElements.define('technical-tabs', TechnicalTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
